



























import { Option } from '@/types/global';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import TraceSearch from '@/views/components/trace/trace-search.vue';
import TraceTable from '@/views/components/trace/trace-table.vue';
import TraceDetail from '@/views/components/trace/trace-detail.vue';
import trace from '../../store/modules/trace';
@Component({
  components: {
    TraceTable, TraceDetail, TraceSearch,
  },
})
export default class Trace extends Vue {
  @State('rocketTrace') private stateTrace!: any;
  @Mutation('SET_EVENTS') private SET_EVENTS: any;
  @Action('rocketTrace/GET_TRACELIST') private GET_TRACELIST: any;
  @Action('rocketTrace/GET_TRACE_SPANS') private GET_TRACE_SPANS: any;

  @Prop({default: {label: 'All', key: ''}})
  private service!: Option;

  @Prop({default: false, type: Boolean})
  private inTopo!: boolean;

  private show: boolean = true;
  private beforeCreate() {
    this.$store.registerModule('rocketTrace', trace);
  }
  private beforeMount() {
     this.SET_EVENTS([]);
  }
  private beforeDestroy() {
    this.$store.unregisterModule('rocketTrace');
  }
}
